<template>
    <NavItem class="dropdown-user dropdown">
        <NavItemLink class="d-flex align-items-center dropdown-toggle legitRipple" :is-dropdown-toggle="true">
            <img :src="profile.getAvatarUrl()" class="rounded-circle mr-2 avatar" width="34" height="34" alt="">
            <span>{{ profile.getFullName() }}</span>
        </NavItemLink>
        <DropDownMenu class="dropdown-menu-right">
            <RouterLinkDropDownMenuItem v-if="project" :href="profileEditUrl"><i class="icon-user"></i> {{ $t("navbar.first.items.profile") }}</RouterLinkDropDownMenuItem>
            <TextDropDownMenuItem @click="logout"><i class="icon-switch2"></i> {{ $t("navbar.first.items.logout") }}</TextDropDownMenuItem>
        </DropDownMenu>
    </NavItem>
</template>
<script>
import NavItem from '../../../../components/navbar/AppNavItem.vue'
import NavItemLink from '../../../../components/navbar/AppNavItemLink.vue'
import DropDownMenu from '../../../../components/dropdown/AppDropDownMenu.vue'
import TextDropDownMenuItem from '../../../../components/dropdown/TextDropDownMenuItem.vue'
import RouterLinkDropDownMenuItem from '../../../../components/dropdown/RouterLinkDropDownMenuItem.vue'
import {generateUrl} from "../../../../../utils";
import {mapGetters} from "vuex";

export default {
    name: 'ProfileTab',
    components: {
        NavItem,
        NavItemLink,
        DropDownMenu,
        TextDropDownMenuItem,
        RouterLinkDropDownMenuItem
    },
    computed: {
        ...mapGetters('route', ['project']),
        profile() {
            return this.$store.getters['profile/profile']
        },
        profileEditUrl() {
            return generateUrl(`app/projects/${this.project.uuid}/settings/profile`, this.project.alias)
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('profile/logoutProfile')
        }
    },
    mounted() {
        this.$store.dispatch('profile/fetchProfile')
    },
}
</script>
<style scoped>
.avatar {
    object-fit: cover;
    object-position: center;
}
</style>
